<script>
	import { Basket } from "../lib/stores/basket";
	import Shipping from "./shipping.svelte";
	import MapLocation from "../lib/components/MapLocation.svelte";
    import MobileNumber from "./mobileNumber.svelte";
	

	//https://crm.lamara.in/products/products/chkpincodeavailablle?pincode=521444

	let pincode="";
	let error = "";

	const checkPincode = e => {
		fetch(`https://crm.lamara.in/products/products/chkpincodeavailablle?pincode=${pincode}`).then(res => res.json()).then(res => {
			if(res.data)
			if(res.data == "available"){
				if(!$Basket.shipping)
				$Basket.shipping = {};
				$Basket.shipping.pincode = pincode;
			}else{
				error = res.data
			}
		})
	}
</script>
{#if $Basket.shipping.pincode }
	<Shipping/>
{:else if $Basket.shipping && $Basket.shipping.pincode && false}
	<MapLocation />
{:else if $Basket.shipping.mobile && !$Basket.shipping.pincode}
<section id="" class="form-page">
	<div class="container">
		<div class="col-md-6 container bg-default">
			<form>
				<div class="form-row">
					<div class="col-md-12 form-group">
						<label class="lbl-txt" for="">Enter your postcode:</label>
						<input type="text" inputmode=”numeric” class="form-control" maxlength="6" bind:value={pincode} placeholder="Postcode" on:change={e => error = ""}>
						{#if error!=""}
							<div class="invalid-feedback">
								{error}
							</div>
						{/if}
					</div>
				</div>
				<hr class="mb-4">
				<button class="btn btn-primary bt-lg btn-block" type="submit" disabled={pincode.length!=6}  on:click|preventDefault={checkPincode}>Continue</button>
			</form>
		</div>
	</div>
</section>
{:else}
<MobileNumber />
{/if}
<style lang="scss">
	.section-title{
		padding: 6em 0 1em 0;
	}

	.form-page {
		padding-top: 100px;
		padding-bottom: 100px;
		min-height: 80vh;
	}

	.invalid-feedback{
		display: block;
	}
</style>